import React, { useState, useEffect } from "react";
import Toolbar from "./components/Toolbar";
import Sidebar from "./components/Sidebar";
import MainContent from "./components/MainContent";
import PrintModal from "./components/PrintModal";
import { useDragAndDrop } from "./hooks/useDragAndDrop";
import { usePrintPreview } from "./hooks/usePrintPreview";
import "./styles/App.css";

const initialSections = [
  { id: "experience", title: "Experience", icon: "💼" },
  { id: "skills", title: "Skills", icon: "⚡" },
  { id: "education", title: "Education", icon: "🎓" },
  { id: "courses", title: "Courses & Certifications", icon: "📚" },
];

export default function App() {
  const [mode, setMode] = useState("styled");
  const [accent, setAccent] = useState("#FF4D00");
  const [pageSize, setPageSize] = useState("A4");

  const dnd = useDragAndDrop(initialSections);
  const printPreview = usePrintPreview();

  // Keep DOM elements synchronized with state context
  useEffect(() => {
    document.body.className = `${mode}-mode`;
  }, [mode]);

  useEffect(() => {
    document.documentElement.style.setProperty("--accent", accent);
  }, [accent]);

  return (
    <>
      <Toolbar
        currentMode={mode}
        setMode={setMode}
        currentAccent={accent}
        setAccent={setAccent}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onOpenPrint={() => printPreview.generatePreview(pageSize, accent)}
        x
      />

      <div
        id="cv-page"
        style={{
          maxWidth: mode === "styled" ? "1100px" : "780px",
          margin: "0 auto",
          padding: "20px 20px 60px",
          display: mode === "styled" ? "grid" : "block",
          gridTemplateColumns: mode === "styled" ? "300px 1fr" : "none",
          gap: "0",
        }}
      >
        <Sidebar />
        <MainContent
          sections={dnd.sections}
          draggedId={dnd.draggedId}
          dragOverId={dnd.dragOverId}
          onDragStart={dnd.handleDragStart}
          onDragOver={dnd.handleDragOver}
          onDrop={dnd.handleDrop}
          onDragEnd={dnd.handleDragEnd}
          mode={mode}
        />
      </div>

      <PrintModal
        isOpen={printPreview.isModalOpen}
        iframeSrc={printPreview.iframeSrc}
        onClose={printPreview.closeModal}
        onPrint={() => {
          const frame = document.querySelector("iframe");
          if (frame) {
            frame.contentWindow.focus();
            frame.contentWindow.print();
          }
        }}
      />
    </>
  );
}
